import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import { customHeaders, programManagementURL } from '../../../../../Containers/Config/index.js';
import apiCall from '../../../apiCall.js';
import { GET_BOOKING_ANALYTICS_DETAILS, GET_BOOKING_ANALYTICS_DETAILS_ERROR, GET_BOOKING_ANALYTICS_DETAILS_SUCCESS } from '../../actions.js';

function* getBookingsAnalyticsDetails({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${programManagementURL}/v1/booking-analytics`,
      method: 'GET',
      headers: {
        ...filteredHeaders,
      },
      params: payload?.urlParams,
    });

    if (response.status === 200) {
      yield put({
        type: GET_BOOKING_ANALYTICS_DETAILS_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_BOOKING_ANALYTICS_DETAILS_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_BOOKING_ANALYTICS_DETAILS_ERROR, payload: error });
  }
}

export function* watchGetBookingsAnalyticsDetails() {
  yield takeEvery(GET_BOOKING_ANALYTICS_DETAILS, getBookingsAnalyticsDetails);
}

function* getBookingsAnalyticsDetailsSaga() {
  yield all([fork(watchGetBookingsAnalyticsDetails)]);
}

export default getBookingsAnalyticsDetailsSaga;
